export default "__VITE_ASSET__CD794sss__"